import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  basename: '/',
});

export default history;



// WEBPACK FOOTER //
// ./src/store/history.js